export default {
  //Albania sq(languagecode) AL(countrycode) Shqipëri / Shqip 
  LandingPage: {
    intro_sub:
      'Podarite drugi život ambalažnom otpadu i učestvujte u zaštiti okoliša',
    title: 'Samsung Upcycle-Packaging',
    sequence1_1: 'Pridružite nam se u smanjenju otpada',
    sequence1_2:
      'za održiv životni okoliš tako što ćete ambalažu Vašeg proizvoda uređaja iskoristiti za korisne stvari. Listajte prema dolje da napravite prvi korak.',
    sequence2_1: 'Predstavljamo Samsung Upcycle-Packaging',
    sequence2_2:
      'TV kutija je specijalno dizajnirana za prenamjenu kako biste Vi mogli dati doprinos okolišu. Možete napraviti razne predmete za domaćinstvo pomoću svoje proizvoda ambalaže.',
    sequence3_1: 'Pratite štampane tačkice na svojoj ambalaži',
    sequence3_2:
      'Izrežite ambalažu kako je naznačeno i sastavite je da dobijete nevjerovatan predmet.',
    sequence4_1: 'Izaberite predmet koji želite napraviti',
    sequence4_2:
      'Listajte prema dolje i odaberite model proizvoda uređaja koji imate na svojoj ambalaži. Zatim pronađite različite opcije dizajna za sebe. A sada započnite svoje putovanje sa predmetom kojeg želite napraviti.',
    selectBox: 'Izaberite svoj proizvoda uređaj',
    moreActivity:
      "Za više informacija o održivim aktivnostima u Samsungu",
    OLED: 'OLED',
    QLED8K: 'QLED', //update
    UHD: 'UHD', //update
    FHD: 'FHD',
    HD: 'HD',
    theFrame: 'The Frame', //update
    theSerif: 'The Serif', //update
    theSero: 'The Sero', //update
    theTerrace: 'The Terrace', //update
    thePremiere: 'The Premiere', //update
    Monitors: 'Monitori', //update
    OdysseyArk:"Odyssey Ark",
    QSoundbar: 'Q Soundbar', //update
    Soundbar: 'Soundbar', //update
    SoundbarSet01:'Soundbar Set 1',
    SoundbarSet02:'Soundbar Set 2',
    TheTerraceSoundbar:'The Terrace Soundbar',
    Soundtower:'Sound Tower',
    BespokeJet: 'BESPOKE Jet\n (Jet)',
    BespokeJetStation:'BESPOKE Jet\n (Clean Station™)',
    BespokeJetNCleanStation : 'BESPOKE Jet&\nClean Station™',
    BespokeJetNCleanStation2 : 'BESPOKE Jet&Clean Station™',
    BespokeCube53:'BESPOKE Cube™ AIR\n(53㎡)',
    BespokeCube70:'BESPOKE Cube™ AIR\n(70㎡)',
    BespokeCube106:'BESPOKE Cube™ AIR\n(106㎡)',
    BespokeCube123:'BESPOKE Cube™ AIR\n(123㎡)',
    Qooker:'Qooker',
    BespokeSlim:'BESPOKE \nSlim',
    TheFreeStyle:"The Freestyle",
    BespokeSlimCleanStation:"BESPOKE Slim&Jet\n(Clean Station™)",
    JetCleanStation:"Jet&\nClean Station™",
    JetCleanStation2:"Jet&Clean Station™",
    BlueSky:"BlueSky \n5500",
    BlueSky3000:"BlueSky \n3000",
    BlueSky3100:"BlueSky \n3100",
    BlueSky5000:"BlueSky \n5000",
    BespokeJetbot:"BESPOKE\n Jet Bot",
    BespokeJetbot2:"BESPOKE Jet Bot",
    BespokeJetbotPlus:"BESPOKE\n Jet Bot+",
    BespokeJetbotPlus2:"BESPOKE Jet Bot+",
    BespokeJetbotAI:"BESPOKE\n Jet Bot AI",
    BespokeJetbotAI2:"BESPOKE Jet Bot AI",
    Canister01:"Canister \n01",
    Canister02:"Canister \n02",
    Jupiter:"Vacuum \nCleaner",
    ref_cube:"BESPOKE Cube",
    WaterPurifier:"Water Purifier",
    LATIN:"LATIN",
    LATIN10:"LATIN10",
    MIRROR:"MIRROR",
    MW5100J:"MW5100J",
    STENA:"STENA",
    // moreActivityLink:
      // 'https://www.samsung.com/al/sustainability/overview/',
      // moreActivityLink:'https://www.samsung.com/al/aboutsamsung/sustainability/strategy/',
      moreActivityLink: 'https://www.samsung.com/al/sustainability/overview/',
    footer: `
    Copyright© 2019 - 2021 Samsung. Të gjitha të drejtat e rezervuara.`,
  },
  ProductPage: {
    selectDesign: 'Izaberite dizajn koji želite napraviti',
    selectDesignDezeen: 'Samsung X Dezeen', //update
    selectDesignSoccer: 'Samsung X Football', 
    tvConsole: 'TV konzola',
    StorageBox: 'Kutija za skladištenje',
    MagazineRack: 'Stalak za novine',
    CatHouse: 'Kućica za mačke',
    CatTunnel: 'Tunel za mačke',
    BookShelf: 'Polica za knjige',
    DeskShelf: 'Polica za radni sto',
    BlackRhino: 'Ugrožene životinje \n crni nosorog', //update
    PolarBear: 'Ugrožene životinje \n polarni medvjed', //update
    SeaTurtle: 'Ugrožene životinje \n morska kornjača', //update
    TheRider: 'The Rider', //update
    Kibe: 'Kibe', //update
    Tessellate: 'Tessellate', //update
    Twist: 'Twist', //update
    AlexCouchArmTable: 'Alex stolić \n za kauč', //update
    BlastOffClubHouse: 'Blast Off \n Club House', //update
    KinokoTable: 'Kinoko sto', //update
    Magnuss: 'Magnuss', //update
    GIO: 'Gio', //update
    PostCardPlanter: 'Držač \n razglednica', //update
    SneakerRack: 'Stalak za \n patike', //update
    TheSoban: 'The Soban', //update
    ToolBox: 'Kutija za alat', //update
    DeskStationary: 'Kutija za pribor za pisanje',
    CoinBank: 'Kasica za kovanice',
    MobileScanner:'Stalak za skeniranje pametnog telefona',
    TabletScanner:'Stalak za skeniranje tableta',
    PetStairs:'Shkallët e kafshëve shtëpiake',
    PetFurniture: 'Pet Friendly Furniture',
    ShoeRackA:'Shoe Rack_A',
    ShoeRackB:'Shoe Rack_B',
    WineRackDog:'Wine Rack Dog',
    WineRack:'Wine Rack',
    mins: 'mins',
    all:'ALL',
    in: 'in',
    inOnly: 'samo in',
    allBoxSize: 'Sve veličine kutija',
    soccergoalpost:'Mini Soccer Goal Post',
   soccerboard:'Table Soccer Board',
   sixpackcarrier:'Six Pack Carrier',
   trophytable:'Trophy Cup Table',
   megaphone:'Cheer Megaphone',
   FreestyleBear:'Small \n Animals \n Polar Bear',
   FreestyleRay:'Small \n Animals \n Ray',
   FreestyleRhino:'Small \n Animals \n Black Rhino',
   FreestyleSeahorse:'Small \n Animals \n See Horse',
   FreestyleWhale:'Small \n Animals \n Whale',
   Mickey:'Mickey Mouse',
   Pluto:'Pluto',
   Diseny:'Samsung X Disney'
  },
  DetailGuidePage: {
    1:'1',
    2:'2',
    3:'3',
    instructions: 'instrukcije',
    prepare: 'Pripremite kutiju',
    LetsDesign: "Hajde da dizajniramo",
    drawParts: 'Nacrtajte dijelove na kutiji',
    note1: 'Imajte na umu da položaj slike može varirati ovisno o zemlji i veličini',
    note2: 'Iscrtajte cijeli crtež tako da stane u kutiju',
    numberSpace: 'broj = razmaci između tačkica',
    diagonal: 'dijagonalno',
    LEFT: 'LIJEVI (dio)',
    RIGHT: 'DESNI (dio)',
    TOP: 'GORNJI (dio)',
    TOP1: 'GORNJI (dio) 1',
    TOP2: 'GORNJI (dio) 2',
    BACK: 'ZADNJI (dio)',
    MIDDLE: 'SREDNJI (dio)',
    MIDDLE2: 'SREDNJI (dio) 2',
    BOTTOM: 'DONJI (dio)',
    FRONT: 'PREDNJI (dio)',
    SIDE: 'BOČNI (dio)',
    secondSIDE: 'DRUGI BOČNI (dio)',
    secondSIDE1: 'DRUGI BOČNI (dio) 1',
    secondSIDE2: 'DRUGI BOČNI (dio) 2',
    LEG: 'NOGA (dio)', //update
    JOINT: 'SASTAV (dio)', //update
    FACE: 'LICE (dio)', //update
    DRAWERBOTTOM: 'DONJA LADICA (dio)', //update
    DRAWERSIDE: 'BOČNA LADICA (dio)', //update
    NOSE: 'NOS (dio)', //update
    HANDLE: 'RUČKA (dio)', //update
    BOTTOMSIDE: 'DONJA BOČNA STRANA (dio)', //update
    TOPSIDE: 'GORNJA BOČNA STRANA (dio)', //update
    WING: 'KRILO (dio)', //update
    cutAndAssemble: "Hajde da isijecamo i sklapamo",
    beCareful: 'Pazite da se ne ozlijedite prilikom upotrebe rezača',
    cutOutParts: 'Isijecite dijelove',
    assemble: 'Sklopite',
    Assemblyguide: 'Vodič za sklapanje', //update
    fold: 'Primjer za preklapanje',
    foldGuide: 'Koristite ivice namještaja kada presavijate karton',
    foldGuideDezeen:
      'Uz pomoć alata za savijanje pritisnite tačkaste linije na kartonu nekoliko puta kako bi se karton lakše savio', //update
    glue: 'Nanesite ljepilo ili traku na površinu jednakim pokretima', //update
    cable: 'Koristite vezice za kablove ili žice da spojite dijelove', //update
    done: 'Gotovo!',
    goBack: 'Vratite se na glavni meni',
  },
  CautionPage: {
    CAUTION: 'PAŽNJA',
    needItem: 'Trebat će Vam ovi predmeti',
    children: 'Djeca trebaju biti u pratnji odraslih',
    mat:
      'Molimo Vas da postavite prostirku na pod kako biste spriječili bilo kakve ogrebotine tokom procesa',
    doNotPutHeavyThing:
      'Nemojte stajati ili sjedati na ovaj namještaj niti pokušavati da stavite teške predmete na njega',
    doNotThrow:
      'Ne bacajte niti udarajte namještaj prema bilo čemu, uključujući ljude i životinje',
    stayAwayFlame: 'Držite se podalje od plamena',
    stayAwayWater: 'Ne približavajte se vodi ili vlažnim uslovima',
    mayDamaged: '* TV ambalaža se može oštetiti tokom procesa transporta',
    companyDoestResponsible:
      '* Kompanija ne snosi nikakvu odgovornost za moguće kvarove ili ozljede tokom ovog procesa',
    cannotBeReturned:
      '* Proizvod sa oštećenim kutijama ne može se vratiti zbog neispunjavanja kvaliteta',
    understand: 'U redu, razumijem',
  },
  PrivacyPolicy: {
    title: 'Privacy policy',
  },
  GoingGreen: {
    visual: {
      title: 'Going Green',
      text1:
        'Za većinu TV ambalaže smo koristili manje papira i tinte u odnosu na prethodnu ambalažu da pojačamo svoju predanost održivosti',
      text2:'',
      text2_special:
        '(* Gore navedeno se ne odnosi na određene modele, uključujući Lifestyle TV uređaje)',
      text3: 'Odaberite tipke ispod da otkrijete još',
    },
    greenIn: {
      title: 'Going Green u TV ambalaži',
      subtitle1: 'Potražite informacije o proizvodu',
      subtitle2: 'Reciklirajuća Samsung Eco-ambalaža',
      desc: 'Potražite naziv modela za više informacija',
      descM: '*Napravite fotografiju broja modela TV uređaja',
      guide: 'naziv modela',
      button: 'Napravite fotografiju',
      button2: 'Idite na Napravite predmete',
      product_info: 'Informacije o proizvodu',
    },
    search: {
      guide: 'Pretražite..',
      noResult: 'Nema rezultata',
      more: 'JOŠ',
      search: 'Pretražite',
      retake: 'Ponovo napravite fotografiju',
      result: 'Rezultat',
    },
    photo: {
      guide1: 'Postavite naziv TV modela unutar okvira',
      guide2: '(na primjer Q800A, UT7000, RU7100, i slično)',
    },
  },
  searchCountrySelect: 'Odaberite zemlju za pretragu'
};
